import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimerService {

  timerData$ = new BehaviorSubject<{ clock: number, clockDelay: number }>({ clock: 0, clockDelay: 0 });
  showTimer$ = new BehaviorSubject<boolean>(false);

  constructor() { }
  
  isTimerVisible() {
    return this.showTimer$.getValue();
  }
}
